import React from "react";
import { BottomNavigation, Box, Link, Typography } from "@mui/material";
import { footerRoot, footerLinkRowSx, footerTextOneLineSx, logoPunctSx } from "./styles";

const Footer: React.FC = () => {
  return (
    <BottomNavigation sx={footerRoot} component="footer" showLabels={false}>
      <Link
        href="https://www.intelliplatforms.com/contact-us"
        sx={footerLinkRowSx}
        underline="none"
        aria-label="Contact IntelliPlatforms"
      >
        <Typography sx={footerTextOneLineSx}>
          Want to chat about all things New Relic? Need Support? Have a Question?{" "}
          <strong>Click our logo to reach out to us.</strong>
        </Typography>

        <Box
          component="img"
          src="/intelliPlatformsLogo.png"
          alt="Intelli Platforms"
          sx={logoPunctSx}
        />
      </Link>
    </BottomNavigation>
  );
};

export default Footer;
